// Third-party Library
import { Card, Row, Col, Typography, Divider, Space, Badge } from "antd"
// import dayjs from "dayjs"

// Constants
import { TEMPLATE } from "../../../../../../constants"

// Services Library
import { TIME } from "../../../../../../services/util"

const { Title, Text } = Typography

const {
    PRETRIP_HISTORY_STATUS_LABEL: statusConfig,
    PRETRIP_HISTORY_STATUS: STATUS
} = TEMPLATE.PRETRIP

const {
    // getCurTime,
    // isBetweenByDate,
    parseDate,
    dayDiff
} = TIME

const SummaryCard = (tableProps) => {

    const dataSource = Object.values(tableProps.dataSource) || []

    // console.log(getCurTime())

    const totalDays = dayDiff(tableProps.startTime, tableProps.endTime)

    const setLenFunc = (status) => dataSource.filter(d => d.status === status).length

    const counts = {
        [STATUS.SUBMITTED]: setLenFunc(STATUS.SUBMITTED),
        [STATUS.MISSING]: totalDays - (setLenFunc(STATUS.SUBMITTED) + setLenFunc(STATUS.OFF)),
        // [STATUS.INCOMPLETE]: 0,
        [STATUS.OFF]: setLenFunc(STATUS.OFF)
    }

    const compliancePct = totalDays > 0 ? Math.round((counts[STATUS.SUBMITTED] / totalDays) * 100) : 0

    const rows = Object.values(statusConfig)
        ?.map(pretrip => ({
            label: pretrip.label,
            status: pretrip.status
        }))

    return (
        <Card size="small" style={{ borderRadius: 12 }}>
            <Title level={5} style={{ marginBottom: 2 }}>Selected Period Summary</Title>
            <Text style={{ color: "#1d78c8", fontSize: 12, display: "block", marginBottom: 12 }}>
                {parseDate(tableProps.startTime)} – {parseDate(tableProps.endTime)}
            </Text>

            <Space direction="vertical" style={{ width: "100%" }} size={8}>
                {rows.map(({ status, label }) => (
                    <Row key={status} justify="space-between" align="middle">
                        <Space size={8}>
                            <Badge color={statusConfig[status].color} />
                            <Text style={{ fontSize: 13 }}>{label}</Text>
                        </Space>
                        <Text strong style={{ fontSize: 13 }}>{counts[status]}</Text>
                    </Row>
                ))}
            </Space>

            <Divider style={{ margin: "12px 0" }} />

            <Text style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 6 }}>
                Compliance Rate
            </Text>
            <Row align="middle" gutter={12}>
                <Col>
                    <Title level={2} style={{ margin: 0, lineHeight: 1 }}>{compliancePct}%</Title>
                </Col>
                <Col>
                    <Text style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.6, display: "block" }}>
                        Submitted / Total Days
                        <br />
                        <strong>{counts[STATUS.SUBMITTED]} / {totalDays} days</strong>
                    </Text>
                </Col>
            </Row>
        </Card>
    )
}


export default SummaryCard